module.exports = __webpack_public_path__ + "static/media/ICON - notificationstopbar.551ab9f4.svg";